import {Component, ContentChild, HostBinding, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AbstractControl, NgModel, ValidationErrors} from '@angular/forms';

@Component({
    selector: 'app-input-error-wrapper',
    templateUrl: './input-error-wrapper.component.html',
    styleUrls: ['./input-error-wrapper.component.scss'],
})

// it shows errors under field
export class InputErrorWrapperComponent implements OnChanges {

    private readonly REQUIRED = 'required';

    private defaultErrorMessages = {required: 'Feld ist erforderlich'};
    private logWarnings = true;

    @Input() errorMessages: { [key: string]: string } = {...this.defaultErrorMessages};
    @Input() fixedHeight = false;

    @HostBinding('class.disabled') get isDisabled() {
        return this.inputRef?.control?.disabled;
    }

    @ContentChild(NgModel) inputRef: NgModel;
    @Input() forceErrorVisibility = false;
    @Input() hint: string;


    showErrorMessage() {
        // control.touched is public getter, dont know why the editor complains about it
        return (this.inputRef?.control?.invalid && this.inputRef?.control?.touched) || this.forceErrorVisibility;
    }

    getErrorMessage() {
        let errors: ValidationErrors = this.inputRef.control.errors;
        // console.log('errors', errors);

        if (!errors) {
            return null;
        }
        let errorsKeys = Object.keys(errors);
        if (errorsKeys.some(errorKey => errorKey === this.REQUIRED)) {
            return this.errorMessages[this.REQUIRED];
        } else {
            let errText = this.errorMessages[errorsKeys[0]];
            if (!errText && this.logWarnings) {
                console.warn('input name: ' + this.inputRef.name + ' - errorMessage is not defined for error key "' +
                    errorsKeys[0] + '", defined error messages:', this.errorMessages)
                this.logWarnings = true;
            }
            return errText;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.errorMessages[this.REQUIRED]) {
            this.errorMessages = {...this.defaultErrorMessages, ...this.errorMessages}
        }
    }
}
